import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import MultimediaElements from 'apps/web_forms/components/MultimediaElements';
import MultimediaIcon from 'apps/web_forms/assets/formicon.svg';
import { COLORS, DEVICES_SIZES } from 'apps/web_forms/utils/constants';
import { setMultimediaPosition } from 'apps/web_forms/slices/multimediaSlice';
import CloseSidepanelIcon from 'apps/web_forms/assets/greater-than-solid.svg';
import OpenSidepanelIcon from 'apps/web_forms/assets/less-than-solid.svg';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const StyledMultimediaContainer = styled.div`
  box-sizing: border-box;
  padding: 1em;
  text-align: center;
  transition: 0.5s;

  .fullScreen {
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
    background: white;
    text-align: center;
    transition: 0.5s;
    z-index: 10;
  }

  p {
    padding: 0.4em 0;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: sticky;
    top: 5em;
  }

  @media (min-width: ${DEVICES_SIZES.tablet}) {
    order: 0;
    width: ${(props) => (props.isOpen ? '39%' : '0')};
    border-left: 1px solid ${COLORS.borderGrey};
    border-bottom: none;
    min-height: 16em;
    .multimedia-elements-container {
      margin: 0.9em;
    }
    .collapse-button {
      visibility: visible;
    }
  }

  @media (max-width: ${DEVICES_SIZES.tablet}) {
    .collapse-button {
      visibility: hidden;
    }
  }

  .collapse-button {
    position: sticky;
    float: left;
    height: 2em;
    width: 1em;
    background-color: #ececec;
    border-radius: 1em;
    border: 2px solid #ececec;
    margin-left: -1.55em;
    top: 50%;
  }
`;

const MediaFormControls = () => {
  const { currentSelectedMultimediaInput, isOpen } = useGlobalSelector();
  const [width, setWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (currentSelectedMultimediaInput.element)
      dispatch(setMultimediaPosition(true));
  }, [currentSelectedMultimediaInput.element]);

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  const isMobile = width <= 768;

  return (
    <StyledMultimediaContainer isOpen={isOpen}>
      {currentSelectedMultimediaInput.element ? (
        <div className={`multimedia-elements-container ${isMobile ? "fullScreen" : ""}`}>
          <MultimediaElements />
        </div>
      ) : (
        <div style={(!isOpen || isMobile) ? { display: 'none' } : {}}>
          <MultimediaIcon />
          <p>Multimedia question will appear here once selected.</p>
        </div>
      )}
      {!currentSelectedMultimediaInput.element && (
        <button
          type="button"
          className="collapse-button"
          onClick={() => dispatch(setMultimediaPosition(!isOpen))}
        >
          {isOpen && <CloseSidepanelIcon />}
          {!isOpen && <OpenSidepanelIcon />}
        </button>
      )}
    </StyledMultimediaContainer>
  );
};

export default React.memo(MediaFormControls);

